import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=21023c06&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21023c06')) {
      api.createRecord('21023c06', component.options)
    } else {
      api.reload('21023c06', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=21023c06&", function () {
      api.rerender('21023c06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2srQr0tepw73l/JS/offershelp.vue"
export default component.exports